import React, { useState } from 'react';
import Wrapper from './styles';
import { useStore } from '../../../hooks/useStore';
import { stores } from '../../../stores';
import { ONSITE_MESSAGE_TAB, OnsiteMessageTab } from '../../../microservices/crm/types';
import UiTabs from '../../ui/tabs/UiTabs';
import { translate } from '../../../services/translate';
import UiButton from '../../ui/button/UiButton';
import { getRoute } from '../../../services/router';
import CrmMessage from '../message/CrmMessage';
import CrmTabItem from '../tab-item/CrmTabItem';
import { CRM_MESSAGE_STEP, onsiteMessageTabsTranslations } from '../../../services/onsite-messages';

export default function CrmDropdown() {
    const [messagesByType] = useStore(stores.crm.messagesByType);
    const [selectedTab, setSelectedTab] = useState<OnsiteMessageTab>(ONSITE_MESSAGE_TAB.NOTIFICATIONS);
    const onsiteMessageTabs = Object.values(ONSITE_MESSAGE_TAB).filter((tab) => tab !== ONSITE_MESSAGE_TAB.ALL);

    function renderContent() {
        if (!messagesByType[selectedTab].messages.length) {
            return (
                <span className="dropdown-content-empty">
                    {translate(onsiteMessageTabsTranslations[selectedTab].empty, 'crm.dropdown')}
                </span>
            );
        }

        return messagesByType[selectedTab].messages
            .slice(0, CRM_MESSAGE_STEP)
            .map((message) => <CrmMessage key={message.id} message={message} />);
    }

    return (
        <Wrapper>
            <UiTabs>
                {onsiteMessageTabs.map((tab) => (
                    <CrmTabItem
                        key={tab}
                        tab={tab}
                        unreadMessagesTotal={messagesByType[tab].unreadMessagesTotal}
                        isSelected={selectedTab === tab}
                        isDisabled={!messagesByType[tab].messages.length}
                        className="dropdown-tab-item"
                        onTabClick={() => setSelectedTab(tab)}
                    />
                ))}
            </UiTabs>
            <div className="dropdown-content">{renderContent()}</div>
            {Boolean(messagesByType[ONSITE_MESSAGE_TAB.ALL].messages.length) && (
                <div className="dropdown-view-all-button">
                    <UiButton block url={getRoute('inbox')} selected={false}>
                        {translate('view-all', 'crm.dropdown')}
                    </UiButton>
                </div>
            )}
        </Wrapper>
    );
}
